import React from "react";
import "./customLoader.css";

const CustomLoader = ({
  size = 120,        // ⬅️ increased size
  logoSrc = "/icon.png",
}) => {
  return (
    <div className="cs-loader-backdrop">
      {/* White overlay below logo */}
      <div className="cs-overlay" />

      {/* Loader */}
      <div
        className="cs-loader"
        style={{ width: size, height: size }}
      >
        <img
          src="/logo.png"
          alt="Loading"
          className="cs-logo"
          draggable={false}
        />
        <div className="cs-reveal-mask" />
      </div>
    </div>
  );
};

export default CustomLoader;
